import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments';

@Injectable({ providedIn: 'root' })
export class RegionListOptionsClient {
    private readonly _http = inject(HttpClient);

    getRegionListOptions<T>(object: string): Observable<T[]> {
        return this._http.get<T[]>(`${environment.apiBaseUrl}${object}/region-list-options`);
    }
}
